import { Pagination, createStyles } from "@mantine/core";
import React from "react";

const useStyles = createStyles((theme) => ({
  pagination: {
    margin: "1rem 0",
    display: "flex",
    alignItems: "end",
    justifyContent: "center",
  },
  summary: {
    "& b": {
      fontWeight: 700,
    },
  },
}));

const CustomPagination = ({
  data,
  itemsPerPage,
  currentPage,
  handlePageChange,
  showSummary = false,
  className,
  summaryClassName,
  paginationStyles,
}) => {
  const { classes, cx } = useStyles();
  const total = Math.ceil((data || 0) / itemsPerPage);
  const start = data ? (currentPage - 1) * itemsPerPage + 1 : 0;
  const end = Math.min(currentPage * itemsPerPage, data || 0);

  return (
    <div className={cx(classes.pagination, className)}>
      {showSummary && (
        <span className={cx(classes.summary, summaryClassName)}>
          Showing <b>{start}–{end}</b> of <b>{data || 0}</b>
        </span>
      )}
      <Pagination
        total={total}
        itemsPerPage={itemsPerPage}
        value={currentPage}
        onChange={handlePageChange}
        color="yellow"
        styles={paginationStyles}
      />
    </div>
  );
};

export default CustomPagination;
